import { createContext, createSignal, onMount, useContext, type Accessor, type JSX } from "solid-js";
import { CraftingResolverService } from "./craftingResolver";

const CraftingResolverContext = createContext<Accessor<CraftingResolverService | null>>(() => null);

export function CraftingResolverProvider(props: { children: JSX.Element }) {
    const [resolver, setResolver] = createSignal<CraftingResolverService | null>(null);

    onMount(async () => {
        const r = new CraftingResolverService();
        await r.initialize();
        setResolver(r);
    });

    return (
        <CraftingResolverContext.Provider value={resolver}>
            {props.children}
        </CraftingResolverContext.Provider>
    );
}

export function useCraftingResolver(): Accessor<CraftingResolverService | null> {
    return useContext(CraftingResolverContext);
}
